import { useState } from 'react';
import Buttons from '../Buttons/Buttons';
import style from './Address.module.css';
import { Skeleton } from '@mui/material';
import { ADMIN_URL } from '../../utils/config';

export default function Address({ hallsData, setSelectedHallData, filial, setFilial, changePage }) {
    const clickFilial = (id) => {
        setFilial(id);
        setSelectedHallData(hallsData[id-1]);
    }

    const click = () => {
        changePage(2);
    }

    return (
        <>
            <div className={style.container}>
                {hallsData ? (
                    hallsData.map((address) => (
                        <div key={`filial-${address.ID}`} className={`${style.block} ${(filial === address.ID && style.selected)}` } onClick={() => clickFilial(address.ID)}>
                            <img src={`${ADMIN_URL}/assets/img/address${address.ID}.png`} alt={address.Address} />
                            <div className={style.text}>{address.AddressFull}</div>
                        </div>
                    ))
                ) : (
                    <>
                        <Skeleton variant="rounded" animation="wave" width={"100%"} height={"50vw"} />
                        <Skeleton variant="rounded" animation="wave" width={"100%"} height={"50vw"} />
                    </>
                )}
            </div>
            <Buttons button1={{ text: "Далее", onClick: click, disabled: !filial}} />
        </>
    )
}
